import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_LoggedIn/cadet/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <div>Hello "/_LoggedIn/cadet/"!</div>
}
